export enum FeedItemType {
  Post = 'Post',
  Proposal = 'Proposal',
}
